import { render } from "./DocumentEditorActions.vue?vue&type=template&id=5d410466&scoped=true"
import script from "./DocumentEditorActions.vue?vue&type=script&lang=js"
export * from "./DocumentEditorActions.vue?vue&type=script&lang=js"

import "./DocumentEditorActions.vue?vue&type=style&index=0&id=5d410466&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d410466"]])

export default __exports__